"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRemoteImageWidthAndHeight = void 0;
/**
 * Calculate the final Width and Height of RemoteImage
 * @param
 * @returns { width, height }
 */
const getRemoteImageWidthAndHeight = ({
  size,
  width,
  height,
  avatarSize
}) => {
  // If height and width and size are not provided, default to avatarSize={m}
  // If size is not provided, use width and height
  const widthAndHeightUndefined = width === undefined && height === undefined;

  // If nothing is defined, we default to avatarSize
  const nothingIsDefined = size === undefined && widthAndHeightUndefined;
  const defaultToAvatarSize = size !== undefined && widthAndHeightUndefined || nothingIsDefined;
  const finalWidth = defaultToAvatarSize ? avatarSize : width;
  const finalHeight = defaultToAvatarSize ? avatarSize : height;
  return {
    width: finalWidth,
    height: finalHeight
  };
};
exports.getRemoteImageWidthAndHeight = getRemoteImageWidthAndHeight;